"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersectMasks = exports.createMask = void 0;
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const omitBy_1 = __importDefault(require("lodash/omitBy"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const createMask = (value) => {
    if ((0, isPlainObject_1.default)(value)) {
        return (0, mapValues_1.default)(value, exports.createMask);
    }
    return true;
};
exports.createMask = createMask;
const isFalsy = (x) => !x;
const intersectMasks = (mask1, mask2) => {
    if ((0, isPlainObject_1.default)(mask1) && (0, isPlainObject_1.default)(mask2)) {
        const newMask = (0, omitBy_1.default)((0, mapValues_1.default)(mask1, (v, k) => (0, exports.intersectMasks)(v, mask2 && mask2[k])), isFalsy);
        if ((0, isEmpty_1.default)(newMask)) {
            return null;
        }
        return newMask;
    }
    if (mask1 && (0, isPlainObject_1.default)(mask2)) {
        return mask2;
    }
    if (mask2 && (0, isPlainObject_1.default)(mask1)) {
        return mask1;
    }
    return !!(mask1 && mask2) || null;
};
exports.intersectMasks = intersectMasks;
//# sourceMappingURL=mask.js.map